import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = async () => {
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/login`, { email, password });

      if (res.data.message === "Login Successful!") {
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("username", res.data.name);
        localStorage.setItem("userId", res.data.user_id);
        navigate("/dashboard");
      } 
      else {
        alert("Invalid login credentials");
      }
    } 
    catch (error) {
      alert(error.response?.data?.message || "Login failed");
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100">

      <div className="bg-white shadow-lg rounded-xl p-8 w-full max-w-md">
        <h2 className="text-3xl font-bold text-center mb-6">Login</h2>

        {/* Email */}
        <label className="block text-gray-600 font-medium">Email</label>
        <input type="email" placeholder="Enter your email" className="w-full p-3 border rounded-lg mt-1 mb-4 focus:outline-none focus:border-blue-500" onChange={(e) => setEmail(e.target.value)} />

        {/* Password */}
        <label className="block text-gray-600 font-medium">Password</label>
        <input onChange={(e) => setPassword(e.target.value)} type="password" placeholder="Enter your password" className="w-full p-3 border rounded-lg mt-1 mb-6 focus:outline-none focus:border-blue-500" />

        <button onClick={handleLogin} className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 rounded-lg transition"> Login </button>

        {/* Signup link */}
        <p className="text-center text-sm text-gray-500 mt-4">
          Don't have an account?{" "}
          <span className="text-blue-600 cursor-pointer hover:underline" onClick={() => navigate("/")}> Sign Up </span>
        </p>
      </div>

    </div>
  );
};

export default Login;
